"use client";

import { ChangeEvent, ReactNode, SelectHTMLAttributes } from "react";
import { cn } from "@/lib/utils";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

export interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  label?: ReactNode;
  leftIcon?: ReactNode;
  rightIcon?: ReactNode;
  placeholder?: string;
  options: { value: string; label: string }[];
}

const FormSelect = ({
  label,
  className,
  options,
  placeholder,
  ...props
}: SelectProps) => {
  return (
    <div>
      {label && (
        <div className="text-sm font-medium text-zinc-800 mb-1 block">
          {label}
        </div>
      )}
      <div className={cn("relative flex items-center", className)}>
        <Select
          onValueChange={(value) =>
            props.onChange?.({
              target: { value },
            } as ChangeEvent<HTMLSelectElement>)
          }
          value={String(props.value ?? "")}
        >
          <SelectTrigger>
            <SelectValue placeholder={placeholder} />
          </SelectTrigger>
          <SelectContent>
            <SelectGroup>
              {options?.map((item) => (
                <SelectItem key={item.value} value={item.value}>
                  {item.label}
                </SelectItem>
              ))}
            </SelectGroup>
          </SelectContent>
        </Select>
      </div>
    </div>
  );
};

FormSelect.displayName = "FormSelect";

export { FormSelect };
